import { QUESTION_STEPS } from '@/components/OnboardingQuestionPage'
import { useTranslation } from 'react-i18next'
import { Form, useLocation, useNavigate, useSubmit } from 'react-router-dom'

const WORDS = [
  'Curious',
  'Anxious',
  'Determined',
  'Overwhelmed',
  'Excited',
  'Scared',
  'Confident',
  'Resigned',
]

export default function FinalWordPage() {
  const submit = useSubmit()
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation()

  const currentPath = location.pathname.split('/').pop() || ''
  const currentIndex = QUESTION_STEPS.indexOf(currentPath)
  const stepNumber = currentIndex + 1
  const totalSteps = QUESTION_STEPS.length
  const progress = totalSteps > 0 ? (stepNumber / totalSteps) * 100 : 0

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault()
    submit(event.currentTarget.form)
  }

  return (
    <div className="bg-app-bg text-primary flex min-h-dvh flex-col font-sans">
      <div className="bg-accent/30 fixed top-0 left-0 z-10 h-full w-1">
        <div
          className="bg-accent w-full transition-all duration-500"
          style={{ height: `${progress}%` }}
        />
      </div>

      <div className="bg-border h-1 w-full">
        <div
          className="bg-accent h-full transition-all duration-500"
          style={{ width: `${progress}%` }}
        />
      </div>

      <div className="mx-auto flex w-full max-w-2xl items-center justify-between px-6 py-4">
        <button
          onClick={() => navigate(-1)}
          className="text-muted hover:text-primary flex cursor-pointer items-center gap-1 bg-transparent text-sm transition-colors"
        >
          ← {t('shared.back', { defaultValue: 'Back' })}
        </button>
        <span className="text-muted text-sm">
          {stepNumber} / {totalSteps}
        </span>
      </div>

      <div className="mx-auto w-full max-w-2xl grow px-6 pt-10 pb-16">
        <span className="text-accent text-xs font-semibold tracking-widest uppercase">
          {t('pages.onboarding.finalWord.eyebrow', {
            defaultValue: 'LAST ONE',
          })}
        </span>

        <h1 className="mt-3 font-serif text-[1.75rem] leading-tight font-bold tracking-tight md:text-[2.25rem]">
          {t('pages.onboarding.finalWord.title', {
            defaultValue:
              'In one word — how do you feel about AI and your future?',
          })}
        </h1>

        <Form method="post" className="mt-10">
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
            {WORDS.map((word) => (
              <label
                key={word}
                className="border-border text-primary hover:border-accent/40 flex cursor-pointer items-center justify-center rounded-xl border bg-white px-4 py-4 text-center font-semibold transition-colors"
              >
                <input
                  className="hidden"
                  name={t('pages.onboarding.finalWord.title', {
                    lng: 'en',
                    defaultValue:
                      'In one word — how do you feel about AI and your future?',
                  })}
                  onChange={handleChange}
                  type="radio"
                  value={word.toLowerCase()}
                />
                {word}
              </label>
            ))}
          </div>
        </Form>
      </div>
    </div>
  )
}
